/**
 * STILGIA 2.0.1 launch flags for the public website.
 * The app backend keeps its own flags (SHOP_ENABLED / PLANS_V2_ENABLED) — these mirror
 * the PUBLIC state only. To launch 2.0.1 on the web: flip both to true and publish.
 */
export const PLANS_V2_PUBLIC = true;
export const SHOP_PUBLIC = true;
export const SHOP_STORE_URL = 'https://shop.stilgia.com';
